export const tr = {
    'incorrect-ecommerce': 'Ecommercе verilerinin aktarımı yanlış ayarlandı',
    'new-auditory': 'İnternette benzer ürünleri aradı',
    'product-page-visit': 'Sitemde ürünleri inceledi',
    'same-products': 'İki grup',
    'similar-goods-for-search': "Reklamlar Arama'da sadece benzer ürünlerle ilgilenen hedef kitleye gösterilir.",
    'status-active': 'Aktif',
    'status-hint-not-show': 'Gösterim yok',
    'status-hint-only-for-context': 'Sadece ağlarda gösterimler',
    'status-hint-show-not-everyone': 'Herkese gösterilmiyor',
    'status-stopped': 'Devre dışı',
    'unavailable-for-search': "Seçilen hedefleme, Arama'daki gösterimleri hariç tutar."
};
